// 设备共享
export default {
    username: '用户名称',
    remarks: '备注',
    PN: '手机号码',
    ASU: '添加共享用户',
    SD: '共享设备',
    VD: '专享设备',
    DN: '设备名',
    CV: '当前专享',
    FS: '飞行状态',
    IF: '飞行中',
    NF: '未飞行',
    deviceshar: '设备共享',
    dev: '设备',
    Shareuser: '共享用户',
    pinputshareuser: '请输入共享用户',
    addsharedev: '添加共享设备',
    owner: '拥有者',
    Exclusiveuser: '专享用户',
    cancelshare: '取消共享',
    exitshare: '退出共享',
    setexclusive: '设置专享',
    cancelexclusive: '取消专享',
    getexclusive: '获取专享',
    selsharedev: '选择共享设备',
    mobile: '手机',
    flymodel: '飞机型号',
    next: '下一步',
    selectsharduser: '选择共享用户',
    user: '帐号',
    userno: '用户不存在或未注册',
    add: '添 加',
    historyuser: '历史共享用户',
    clearhistory: '清除历史',
    editsharedev: '编辑共享设备',
    sharenum: '共享数量',
    manycancel: '批量取消',
    setexclusiveuser: '设置专享用户',
    pselectdev: '请先选择要共享的设备',
    pselectshareuser: '请选择要共享的用户',
    pselectexcuser: '请先选中要专享的用户',
    cancelcdevshare: '此操作将取消此设备共享,是否继续',
    cancelchedevshare: '此操作将取消选中设备共享,是否继续',
    cancelexitshare: '此操作退出此设备共享,是否继续',
    exited: '已取消退出',
    canceled: '已取消',
    onlysetshareuser: '只能设置一个专享用户',
    tip_del: '删除用户后，该用户将无法共享和专享设备，是否进行删除？',
    tip_MODID: '数据项意义：设备名(当前专享用户)',
    tip_PEDN: '请输入设备名',
    tip_MODID1: '数据项意义：设备名(当前专享用户)，飞行中无法勾选',
}